import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';
import { TabletSize } from '@features/TrainerTools/constants';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  return {
    rootCollection: {
      width: '790px !important',
      maxWidth: '94vw',
      //transition: 'all 0.2s ease',

      [breakpoints.down(ScreenSizes.PcLarge)]: {
        height: 'fit-content',
        // width: '94vw !important',
        width: '630px !important',
      },
      [breakpoints.down(TabletSize)]: {
        width: '454px !important',
      },
      [breakpoints.down(480)]: {
        width: '370px !important',
        maxWidth: '94vw',
      },
    },
    root: {
      [breakpoints.down(ScreenSizes.PcLarge)]: {
        height: 'fit-content',
        transition: 'all 0.2s ease',
      },
    },
  };
};
